module.exports = __webpack_public_path__ + "img/sixpackcarrier2.b7a7a556.jpg";